angular.module("SettingsApp").factory("InviteUserToTeamFactory", ["$resource", function ($resource) {
    return $resource("/api/v1.0/profiles/invite-user/", {}, {
        invite: {
            method: 'POST'
        }
    });
}]);